module.exports = __webpack_public_path__ + "static/img/companyBackground2.d4c27623.png";